<p-multiSelect
    class="form-control"
    [options]="options"
    defaultLabel="Select Competencies..."
    [style]="{ width: '100%' }"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
    >
  <ng-template let-option let-i="index" pTemplate="item">
    <ng-container *ngIf="!option.allWorkerRequired">
      <i class="fas fa-user"></i>
    </ng-container>
    <ng-container *ngIf="option.allWorkerRequired">
      <i class="fas fa-users"></i>
    </ng-container>
    {{ option.label }}
  </ng-template>

</p-multiSelect>
